

export const reducer=(state=null,action)=>{
    switch(action.type){
default:return state;
    }
}
